export default function SectionBorder() {
  return (
    <div className="hidden sm:block">
      <div className="py-8">
        <div className="border-t border-gray-200"></div>
      </div>
    </div>
  );
}
